"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranularityTabs = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sortBy_1 = tslib_1.__importDefault(require("lodash/sortBy"));
var Tabs_1 = require("../Tabs/Tabs");
var i18n_1 = require("../constants/i18n");
var locales_1 = require("../../locales");
var granularityOrders = {
    "GDC.time.year": 0,
    "GDC.time.quarter": 1,
    "GDC.time.month": 2,
    "GDC.time.week_us": 3,
    "GDC.time.date": 4,
    "GDC.time.hour": 5,
    "GDC.time.minute": 6,
};
var sortGranularities = function (granularities) {
    return sortBy_1.default(granularities, function (granularity) { return granularityOrders[granularity]; });
};
exports.GranularityTabs = function (_a) {
    var availableGranularities = _a.availableGranularities, onSelectedGranularityChange = _a.onSelectedGranularityChange, selectedGranularity = _a.selectedGranularity;
    return (react_1.default.createElement(Tabs_1.TabsWrapper, { className: "gd-relative-filter-form-granularity-tabs s-relative-filter-form-granularity-tabs" }, sortGranularities(availableGranularities).map(function (granularity) {
        var intlGranularity = i18n_1.granularityIntlCodes[granularity];
        return (react_1.default.createElement(Tabs_1.Tab, { key: granularity, selected: granularity === selectedGranularity, onClick: function () { return onSelectedGranularityChange(granularity); }, className: "s-granularity-" + intlGranularity },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: locales_1.messages[intlGranularity].id })));
    })));
};
//# sourceMappingURL=GranularityTabs.js.map